const initialState = {
  index: [],
  data: {},
};

const Appointment = (state = initialState, action) => {
  switch (action.type) {
    case "CONTENT_APPOINTMENT_INDEX":
      return { ...state, index: action.payload.index };
    case "CONTENT_APPOINTMENT_DATA":
      return { ...state, data: action.payload.data };
    case "CONTENT_APPOINTMENT_RESET":
      return initialState;
    default:
      return state;
  }
};

export default Appointment;
